import type { GalleryCategory } from "@/types";

export const galleryCategoryLabels: Record<GalleryCategory, string> = {
  mudanzas: "Mudanzas",
  acarreos: "Acarreos",
  eventos: "Eventos",
  distribucion: "Distribución",
  transporte: "Transporte",
  empresarial: "Servicios empresariales",
};

export const galleryCategoryOptions: { value: GalleryCategory; label: string }[] = [
  { value: "mudanzas", label: "Mudanzas" },
  { value: "acarreos", label: "Acarreos" },
  { value: "eventos", label: "Eventos" },
  { value: "distribucion", label: "Distribución" },
  { value: "transporte", label: "Transporte" },
  { value: "empresarial", label: "Servicios empresariales" },
];